(() => {
  if (window.teRelatedProductQuickAddReady) return;
  window.teRelatedProductQuickAddReady = true;

  const getCartUI = () => document.querySelector('cart-drawer') || document.querySelector('cart-notification');

  const setButtonState = (button, state, originalMarkup) => {
    if (!button) return;

    if (state === 'loading') {
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      button.textContent = 'Adding...';
      return;
    }

    if (state === 'added') {
      button.disabled = true;
      button.removeAttribute('aria-busy');
      button.textContent = 'Added!';
      return;
    }

    button.disabled = false;
    button.removeAttribute('aria-busy');
    button.innerHTML = originalMarkup;
  };

  const openCartDrawer = (cartUI) => {
    const cartDrawer = cartUI || document.querySelector('cart-drawer');
    if (cartDrawer && typeof cartDrawer.open === 'function') {
      cartDrawer.open();
    }
  };

  document.addEventListener(
    'submit',
    async (event) => {
      const form = event.target.closest('[data-te-quick-add-form]');
      if (!form) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      if (form.dataset.teSubmitting === 'true') return;
      form.dataset.teSubmitting = 'true';

      const button = form.querySelector('[data-te-quick-add-button]');
      const originalMarkup = button?.innerHTML || 'Add to Cart';
      const cartUI = getCartUI();
      const formData = new FormData(form);

      setButtonState(button, 'loading', originalMarkup);

      if (cartUI && typeof cartUI.getSectionsToRender === 'function') {
        formData.set(
          'sections',
          cartUI
            .getSectionsToRender()
            .map((section) => section.id)
            .join(',')
        );
        formData.set('sections_url', window.location.pathname);
        cartUI.setActiveElement?.(document.activeElement);
      } else {
        formData.set('sections', 'cart-drawer,cart-icon-bubble');
        formData.set('sections_url', window.location.pathname);
      }

      try {
        const cartAddUrl = window.routes?.cart_add_url || '/cart/add.js';
        const response = await fetch(cartAddUrl, {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
          },
          body: formData,
        });

        const data = await response.json();
        if (!response.ok || data.status) {
          throw new Error(data.description || data.message || 'Unable to add this item to cart.');
        }

        if (cartUI && typeof cartUI.renderContents === 'function') {
          cartUI.renderContents(data);
          window.setTimeout(() => openCartDrawer(cartUI), 0);
        } else {
          openCartDrawer(cartUI);
        }

        setButtonState(button, 'added', originalMarkup);
        window.setTimeout(() => setButtonState(button, 'normal', originalMarkup), 1000);
      } catch (error) {
        console.error('TE related product quick add error:', error);
        setButtonState(button, 'normal', originalMarkup);
        window.alert(error.message || 'Unable to add this item to cart. Please try again.');
      } finally {
        delete form.dataset.teSubmitting;
      }
    },
    true
  );
})();
